import { formatNumber } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';

@Component({
  selector: 'app-segmentaciones',
  templateUrl: './segmentaciones.component.html',
  styleUrls: ['./segmentaciones.component.scss'],
})


export class SegmentacionesComponent implements OnInit {

  myOptions = {
    'placement': 'bottom',
    'showDelay': 0,
    'hideDelay': 300,
    'trigger': 'hover',
    'tooltip-class':'tooltip-inner'
  }




  clasePuntos: any;
  clientePuntos: any;
  nombres: any;
  clientePuntosObjetivo: any;
  fechaRipleyPuntos: any;
  puntaje: any;
  puntajeFaltante: any;
  puntajePorcentaje: any;
  totalRipleyPuntos: any;
  totalRipleyPuntos_: any;
  MensajeTooltip: string;
  MensajeTooltipInfoVioleta: string;
  MensajeTooltipInfoWhite: string;

  objMensajeCategoria = {
    mantener: "mantenerte en la categoría",
    subir: "subir a categoría"
  };
  objPuntosCategoria = {
    plus: "2,500",
    silver: "5,000",
    gold: "11,000"
  };
  objCategorias = {
    ripley: "RIPLEY",
    plus: "PLUS",
    silver: "SILVER",
    gold: "GOLD"
  }

  mensajeCategoria: string = "";
  puntosCategoria: string = "";
  clienteCategoria: string = "";

  public windowsize: any;

  lista = [
        {
            "name": "CLASE_PUNTOS",
            "value": "3.PLUS"
        },
        {
            "name": "CLASE_PUNTOS_CLIENTES",
            "value": "PLUS"
        },
        {
            "name": "CLASE_PUNTOS_CLIENTES_OBJETIVO",
            "value": "Silver Prime"
        },
        {
            "name": "CLASE_PUNTOS_OBJETIVO",
            "value": "03.- SILVER"
        },
        {
            "name": "DOCUMENTO",
            "value": "84644135"
        },
        {
            "name": "FECHA_RIPLEYPUNTOS",
            "value": ""
        },
        {
            "name": "FLG_CLIENTE",
            "value": "1"
        },
        {
            "name": "ID_CLIENTE",
            "value": "000008464413501"
        },
        {
            "name": "NOMBRE",
            "value": "Name1 4644135"
        },
        {
            "name": "PUNTAJE",
            "value": "7,500"
        },
        {
            "name": "PUNTAJE_FALTANTE",
            "value": "-2,500"
        },
        {
            "name": "PUNTAJE_PORCENTAJE",
            "value": "150"
        },
        {
            "name": "RIPLEYPUNTOS",
            "value": "562556"
        },
        {
            "name": "TIPO_DOCUMENTO",
            "value": "01"
        }
  ];

  constructor(
    @Inject(LOCALE_ID) public locale: string
  ) { }

  ngOnInit() {
   // this.MensajeTooltip = "Para subir a la categoría Gold <br/>necesitas obtener 11,000 puntos <br/>categoría durante el 2022.";
    this.cargaInicial();
  
  }

  cargaInicial() {
    const objData = localStorage.getItem('objData');
    //console.log('cargaInicial');
    //console.log(objData);

    if (objData) {
      const listData = JSON.parse(objData);
      // const listData = this.lista;
      //console.log(listData);
      if (listData.length > 0) {        
        this.setValuesCliente(listData);
        this.setSegmentClient();
      } else {
        localStorage.setItem('idSeccionSegmentador', 'divSegmentadorNoClientes');
        this.clientePuntos = 'NOCLIENTES';        
      }
    } else {
      localStorage.setItem('idSeccionSegmentador', 'divSegmentadorNoClientes');
      this.clientePuntos = 'NOCLIENTES';      
    }
    this.MensajeTooltipInfoWhite="Son los puntos acumulados entre el 01 de enero y el 31 de diciembre de cada año que te permiten acceder a las categorías Plus, Silver y Gold. No se consideran los puntos adquiridos por bonos y/o campañas promocionales.";
    this.MensajeTooltipInfoVioleta="Puntos que puedes canjear por Gift Cards, Súper Canjes, Experiencias o Millas. Tienen vigencia de 12 meses (excepto puntos categoría Gold con vigencia de 24 meses).";
  }

  setValuesCliente(listData: any) {
    for (const row of listData) {
      this.applyRowValue(row.name, row.value);
    }
  }
  private applyRowValue(name: string, value: string) {
    const directMap: { [key: string]: string } = {
      'CLASE_PUNTOS': 'clasePuntos',
      'CLASE_PUNTOS_CLIENTES': 'clientePuntos',
      'CLASE_PUNTOS_CLIENTES_OBJETIVO': 'clientePuntosObjetivo',
      'FECHA_RIPLEYPUNTOS': 'fechaRipleyPuntos',
      'NOMBRE': 'nombres',
      'PUNTAJE': 'puntaje'
    };
    if (directMap[name] !== undefined) {
      (this as any)[directMap[name]] = value;
    } else if (name === 'PUNTAJE_FALTANTE') {
      this.puntajeFaltante = value === '' ? '0' : value;
    } else if (name === 'PUNTAJE_PORCENTAJE') {
      this.puntajePorcentaje = value === '' ? '0' : value;
    } else if (name === 'RIPLEYPUNTOS') {
      this.totalRipleyPuntos_ = value;
      this.totalRipleyPuntos = formatNumber(this.totalRipleyPuntos_, this.locale, '1.0-5');
    }
  }
  setSegmentClient() {
    this.nombres = this.nombres + '!';
    this.windowsize = window.innerWidth;
    const year = new Date().getFullYear();
    //this.MensajeTooltip = "Para subir a la categoría Gold <br/>necesitas obtener 11,000 puntos <br/>categoría durante el 2022.";
    if (this.clientePuntos.toUpperCase() === 'SILVER PRIME') {
      localStorage.setItem('idSeccionSegmentador', 'divSegmentadorSiver');
      this.MensajeTooltip= "Para subir a la categoría Gold necesitas obtener 11,000 puntos categoría durante el "+year+".";

      if (this.clientePuntos === this.clientePuntosObjetivo) {
        this.mensajeCategoria = this.objMensajeCategoria.mantener;
        this.puntosCategoria = this.objPuntosCategoria.silver;
        this.clienteCategoria = this.objCategorias.silver;
      } else {
        this.mensajeCategoria = this.objMensajeCategoria.subir;
        this.puntosCategoria = this.objPuntosCategoria.gold;
        this.clienteCategoria = this.objCategorias.gold;
      }

    } else if (this.clientePuntos.toUpperCase() === 'GOLD PRIME') {
      localStorage.setItem('idSeccionSegmentador', 'divSegmentadorGold');
      this.MensajeTooltip= "Para mantenerte en la categoría Gold necesitas obtener 11,000 puntos categoría durante el "+year+".";
    
      this.mensajeCategoria = this.objMensajeCategoria.mantener;
      this.puntosCategoria = this.objPuntosCategoria.gold;
      this.clienteCategoria = this.objCategorias.gold;

    } else if (this.clientePuntos.toUpperCase() === 'PLUS') {
      localStorage.setItem('idSeccionSegmentador', 'divSegmentadorPlus');
      this.MensajeTooltip= "Para subir a la categoría Silver necesitas obtener 5000 puntos categoría durante el "+year+".";

      if (this.clientePuntos === this.clientePuntosObjetivo) {
        this.mensajeCategoria = this.objMensajeCategoria.mantener;
        this.puntosCategoria = this.objPuntosCategoria.plus;
        this.clienteCategoria = this.objCategorias.plus;
      } else {
        this.mensajeCategoria = this.objMensajeCategoria.subir;
        this.puntosCategoria = this.objPuntosCategoria.silver;
        this.clienteCategoria = this.objCategorias.silver;
      }

    } else if (this.clientePuntos.toUpperCase() === 'RIPLEY') {
      localStorage.setItem('idSeccionSegmentador', 'divSegmentadorSiver');
      this.MensajeTooltip= "Para subir a la categoría Plus necesitas obtener 2,500 puntos categoría durante el "+year+".";

      this.mensajeCategoria = this.objMensajeCategoria.subir;
      this.puntosCategoria = this.objPuntosCategoria.plus;
      this.clienteCategoria = this.objCategorias.plus;
    }
  }
}
